export default function getOntologyKeyRegex(ontologyKey, regexKey, getDefaultRegex) {
  if (typeof ontologyKey === 'string')
    return getDefaultRegex(ontologyKey)
  else if (ontologyKey[regexKey])
    return ontologyKey[regexKey]
  else return getDefaultRegex(ontologyKey.key)
}
